export const MODEL_CUSTOM_VOCABULARY_ADD_RECORDS = 'MODEL_CUSTOM_VOCABULARY_ADD_RECORDS';
export const MODEL_CUSTOM_VOCABULARY_ADD_RECORD = 'MODEL_CUSTOM_VOCABULARY_ADD_RECORD';
export const MODEL_CUSTOM_VOCABULARY_REMOVE_RECORDS = 'MODEL_CUSTOM_VOCABULARY_REMOVE_RECORDS';
export const MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD = 'MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD';
export const MODEL_CUSTOM_VOCABULARY_SET_LIST = 'MODEL_CUSTOM_VOCABULARY_SET_LIST';
export const MODEL_CUSTOM_VOCABULARY_SET_RECORDS = 'MODEL_CUSTOM_VOCABULARY_SET_RECORDS';
export const MODEL_CUSTOM_VOCABULARY_IDENTITY = 'vocabularyName';
